import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import api, { formatApiError } from "@/lib/api";
import { LanguageSwitcher } from "@/components/common";
import { toast } from "sonner";

export default function ResetPassword() {
  const { t } = useTranslation();
  const [params] = useSearchParams();
  const token = params.get("token");
  const nav = useNavigate();
  const [f, setF] = useState({ new_password: "", confirm: "" });
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault(); setErr("");
    if (f.new_password !== f.confirm) return setErr(t("Passwords do not match"));
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: f.new_password });
      toast.success(t("Password reset — please log in"));
      nav("/login");
    } catch (e2) { setErr(formatApiError(e2.response?.data?.detail) || e2.message); }
    finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background px-4">
      <div className="w-full max-w-md">
        <div className="flex justify-end mb-4"><LanguageSwitcher /></div>
        <Link to="/" className="font-display font-extrabold text-2xl tracking-tight text-primary block text-center mb-8">Deliber<span className="text-secondary">.</span>Act</Link>
        <div className="border border-border bg-white p-8">
          <h1 className="font-display text-2xl font-bold tracking-tight mb-6">{t("Choose a new password")}</h1>
          {!token ? (
            <p className="text-sm text-destructive" data-testid="reset-no-token">{t("This reset link is invalid. Please request a new one.")}</p>
          ) : (
            <form onSubmit={submit} className="space-y-4">
              <div><label className="overline block mb-1">{t("New password")}</label><input data-testid="reset-new" type="password" required minLength={6} value={f.new_password} onChange={(e) => setF({ ...f, new_password: e.target.value })} className={ic} /></div>
              <div><label className="overline block mb-1">{t("Confirm password")}</label><input data-testid="reset-confirm" type="password" required value={f.confirm} onChange={(e) => setF({ ...f, confirm: e.target.value })} className={ic} /></div>
              {err && <p data-testid="reset-error" className="text-sm text-destructive">{err}</p>}
              <button data-testid="reset-submit" disabled={busy} className="w-full bg-primary text-white py-2.5 rounded-sm font-semibold hover:bg-primary/90 transition-colors disabled:opacity-60">{busy ? t("Saving…") : t("Reset password")}</button>
            </form>
          )}
          <p className="text-sm text-muted-foreground mt-6 text-center"><Link to="/login" className="text-primary font-semibold">{t("Back to log in")}</Link></p>
        </div>
      </div>
    </div>
  );
}
const ic = "w-full border border-border bg-background rounded-sm px-3 py-2 focus:ring-2 focus:ring-primary/50 focus:border-primary outline-none";
